// The UI that consumes this will not sort. The order the items are entered is the order that they are displayed.
export const changelog = [
  // !! Add new entries to the top!
  {
    title: 'Profile updates',
    date: 'August 6th 2019',
    entries: [
      'Regenerating APIKeys would not save into the current browser session'
    ]
  }
];
